import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './css/Mapballoon.css';


class MapBalloon extends Component {
    constructor(props) {
        super(props);
        
    }
    componentDidMount(){

    }
    componentDidUpdate(){
       
    }
 

    render() {

        return (
            <div className="tile" style={{height:200}}>
                <div className="front">
                    <div className="header "><t className="balloon-device_no"></t>
                        <i className="fa fa-clock-o small-text pull-right balloon-time" style={{position:"absolute",bottom:5,right:5,color:"#ccc"}} ></i>      
                    </div>
                        
                    <div className="dates">
                        <div className="start">
                            <strong >ระยะเวลาขับ</strong><t className="balloon-duration"> </t><br/>
                            <strong  >สถานที่</strong><t className="balloon-place"></t>
                            <span></span>
                            
                            
                        </div>
                        <div className="ends">
                            <a className="balloon-street_view_position" href="" target="_blank">
                                <img className="img-rounded" style={{width: 100}} src="./images/logo/street_view.png" /><br/>
                                {/* <i className="fa fa-map-marker small-text " 
                                style={{position:"absolute",bottom:-15,left:5,fontSize:11,color:"#19a15e"}} >พิกัด <t className="balloon-position"></t></i>  */}
                            </a>
                            <div className = "balloon-google-map">
                                <a  className = "balloon-google_map_position" href="" target="_blank">
                                    <i className="fa fa-map-marker " 
                                        style={{fontSize:14, marginRight:3, color:"blue"}} >
                                    </i>
                                    ดู Google Map
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    <div className="stats">
                
                        <div>
                            <strong>ความเร็ว</strong>
                            <t className="balloon-speed"></t>
                        </div>
                        
                        <div>
                            <strong>ซื่อคนขับ</strong>
                            <t className="balloon-driver_name"></t>
                        </div>
                        
                        <div>
                            <strong>เบอร์โทร</strong>                    
                            <t className="balloon-driver_contact"></t>
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    }
}


export default MapBalloon;


// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/MapBalloon/Mapballoon.js